<path
    d="M45.8333 23.0831V24.9997C45.8308 29.4923 44.376 33.8636 41.6861 37.4619C38.9962 41.0601 35.2152 43.6924 30.907 44.9662C26.5988 46.24 21.9943 46.087 17.7801 44.5301C13.566 42.9732 9.96803 40.0958 7.52283 36.3269C5.07764 32.5581 3.91623 28.0998 4.21183 23.617C4.50742 19.1342 6.24418 14.8671 9.16308 11.452C12.082 8.03684 16.0266 5.65676 20.4087 4.66669C24.7908 3.67661 29.3756 4.12959 33.4792 5.95805"
    stroke="#121212"
    stroke-width="0.8"
    stroke-linecap="round"
    stroke-linejoin="round"
/>
<path
    d="M45.8333 8.33333L25 29.1875L18.75 22.9375"
    stroke="#121212"
    stroke-width="0.8"
    stroke-linecap="round"
    stroke-linejoin="round"
/>
